import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "not-found-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "Not Found page", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponentVue = _resolveComponent("HeaderComponentVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderComponentVue),
    _hoisted_2
  ]))
}